import { Box, Typography } from "@mui/material";
import { CKEditor } from "ckeditor4-react";
import { useEffect, useRef, useState } from "react";
import FullScreenLoader from "../full-screen-loader";
import Color from "../../theme/color";

const RichBoxUi = ({ onChangeText, initialData }: RichBoxUiProps) => {
  const [renderDelayed, setRenderDelayed] = useState(false);
  const [loading, setLoading] = useState(true);
  const editorRef = useRef<any>();
  const ckEditor = {
    extraPlugins: "scayt,font",
    scayt_autoStartup: true,
    removeButtons:
      "RemoveFormat,Cut,Copy,Paste,About,Undo,Redo,Anchor,Image,Source,Styles,PasteText,PasteFromWord,Subscript,Superscript",
  };

  useEffect(() => {
    setTimeout(() => {
      setRenderDelayed(true);
      setLoading(false);
    }, 1200);
  }, [initialData]);

  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="h6" style={{ color: Color.color22 }} gutterBottom>
        Event Description
      </Typography>
      {renderDelayed && (
        <CKEditor
          ref={editorRef}
          initData={initialData || "<p></p>"}
          config={ckEditor}
          onChange={(event: any) => {
            let data = event.editor.getData() || "<p></p> ";
            onChangeText(data);
          }}
        />
      )}
      <FullScreenLoader open={loading} />
    </Box>
  );
};

export default RichBoxUi;

interface RichBoxUiProps {
  onChangeText: (event: any) => void;
  styles?: React.CSSProperties;
  initialData?: any;
  route?: any;
}
